var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('page-title-bar'),_c('v-container',{attrs:{"fluid":"","grid-list-xl":""}},[_c('app-card',{attrs:{"fullBlock":true}},[_c('div',{staticStyle:{"width":"100%","height":"500px"},attrs:{"id":"world-map"}})])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }